import { FontResponseType } from '@/components/shared/Theme/types';

/**
 * Transforms backend font response to React state format, converting snake_case keys to camelCase.
 *
 * @param fontResponse The font data received from the backend, with snake_case keys.
 * @returns An object formatted for React state, with camelCase keys.
 */
export const mapFontResponseToState = (fontResponse: FontResponseType) => {
  const { id, name, font_family, format, url, is_system_default, is_public } = fontResponse;

  return {
    id,
    name,
    fontFamily: font_family,
    format,
    url,
    isSystemDefault: is_system_default,
    isPublic: is_public,
  };
};
